<script>
    import { onMount } from 'svelte'
    import { homeURL, pubsConfig } from '../../store.js'
    import { getHash, fireHashChange } from '../../js/hash-scroll.js'

    export let pages
    export let indexShow

    onMount(() => {
        const hideIndex = () => { indexShow = false }
        const links = document.querySelectorAll('#indexInner a')
        for (const link of links) {
            link.addEventListener('click', hideIndex)
        }
    })

    function getTextAlignment (index) {
        return ['left', 'center', 'right'][index % 3]
    }

    function addPublicationFilter (categoryName) {
        pubsConfig.update(config => {
            const newConfig = { ...config }
            newConfig.filterBy = [categoryName]
            return newConfig
        })
    }
</script>

<div id="indexInner">
    {#each pages.filter(page => page.meta.type != 'one off page') as page, index}
        <div class="page" style="text-align: {getTextAlignment(index)}; color: {page.circuit_color} !important;">
            <a class="pageTitle" href="{homeURL}/{getHash(page.title)}">
                {page.title}
            </a>
            <ul>
                {#if page.meta.type == 'home.PublicationListingsPage'}
                    {#each page.categories.filter(pub => pub.priority) as category, index}
                        <li>
                            <a
                                class="publicationCategoryLink"
                                href="{homeURL}/{getHash(page.title)}"
                                on:click={addPublicationFilter(category.name)}
                            >
                                {category.name}
                            </a>
                        </li>
                    {/each}

                {:else if page.meta.type == 'home.TeachingPage'}
                    <li>
                        <a
                            on:click={e => fireHashChange(e, 'courses', page.meta.slug)}
                            href="{homeURL}/{page.meta.slug}#!courses"
                        >
                            {page.titleCourses}
                        </a>
                    </li>
                    <li>
                        <a
                            on:click={e => fireHashChange(e, 'outreach', page.meta.slug)}
                            href="{homeURL}/{page.meta.slug}#!outreach"
                        >
                            {page.titleOutreach}
                        </a>
                    </li>
                    {#each page.sections as section}
                        <li>
                            <a
                                on:click={e => fireHashChange(e, getHash(section.title), page.meta.slug)}
                                href="{homeURL}/{page.meta.slug}#!{getHash(section.title)}"
                            >
                                {section.title}
                            </a>
                        </li>
                    {/each}
                {:else if page.meta.type == 'home.NewsListingPage'}
                    <li>
                        <a
                            on:click={e => fireHashChange(e, 'labupdates', page.meta.slug)}
                            href="{homeURL}/{page.meta.slug}#!labupdates"
                        >
                            {page.UpdatesTitle}
                        </a>
                    </li>
                    <li>
                        <a
                            on:click={e => fireHashChange(e, 'alabatwork', page.meta.slug)}
                            href="{homeURL}/{page.meta.slug}#!alabatwork"
                        >
                            {page.LabAtWorkTitle}
                        </a>
                    </li>
                    <li>
                        <a
                            on:click={e => fireHashChange(e, 'tshirts', page.meta.slug)}
                            href="{homeURL}/{page.meta.slug}#!tshirts"
                        >
                            T-Shirts
                        </a>
                    </li>
                {:else if page.meta.type == 'home.PersonListingPage'}
                    {#each page.categories as category}
                        <li>
                            <a
                                on:click={e => fireHashChange(e, getHash(category), page.meta.slug)}
                                href="{homeURL}/{page.meta.slug}#!{getHash(category)}"
                            >
                                {category}
                            </a>
                        </li>
                    {/each}
                    <li>
                        <a
                            on:click={e => fireHashChange(e, 'contact', page.meta.slug)}
                            href="{homeURL}/{page.meta.slug}#!contact"
                        >
                            Contact
                        </a>
                    </li>
                {:else if page.meta.type == 'home.ResourcesPage'}
                    {#each page.sections as section}
                        <li>
                            <a
                                on:click={e => fireHashChange(e, getHash(section.title), page.meta.slug)}
                                href="{homeURL}/{page.meta.slug}#!{getHash(section.title)}"
                            >
                                {section.title}
                            </a>
                        </li>
                    {/each}
                    <li>
                        <a
                            on:click={e => fireHashChange(e, 'imagesandmovies', page.meta.slug)}
                            href="{homeURL}/{page.meta.slug}#!imagesandmovies"
                        >
                            Images and Movies
                        </a>
                    </li>

                {:else}
                    {#each page.sections as section}
                        <li>
                            <a
                                on:click={e => fireHashChange(e, getHash(section.title), page.meta.slug)}
                                href="{homeURL}/{page.meta.slug}#!{getHash(section.title)}"
                            >
                                {section.title}
                            </a>
                        </li>
                    {/each}
                {/if}
            </ul>
        </div>
    {/each}
    <div class="indexFooter">
        <div class="page left">
            <a href="https://www.caltech.edu/" target="_blank">
                <img src="assets/caltechSeal.png" alt="Caltech seal" />
                <img src="assets/CaltechType.png" alt="Caltech logo" />
            </a>
            <a class="bbeLink" href="http://www.bbe.caltech.edu/" target="_blank">
                Division of Biology
                <br />
                and Biological Engineering
            </a>
        </div>
        <div class="page center">
            <a href="https://www.hhmi.org/" target="_blank">
                <img src="assets/HHMI-logo.jpg" alt="Howard Hughes Medical Institute logo" />
            </a>
        </div>
        <div class="page right">
            <p class="diagramsLink">
                <a href="{homeURL}/diagrams">
                    READ ABOUT THE DIAGRAMS ON OUR HOME PAGE
                </a>
            </p>
        </div>
    </div>
</div>

<style lang="scss">
    @import "../../styles/vars";

    .publicationCategoryLink {
        text-transform: capitalize;
    }

    .page {
        grid-column: span 1;
        vertical-align: middle;

        &.left {
            display: flex;
            align-items: center;

            a {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: left;
            }

            img {
                max-height: 75px;
                max-width: 75px;
                margin: 0 10px;
            }

            .bbeLink {
                margin-left: 1rem;
                font-size: 0.95rem;
                font-family: "Work Sans";
                line-height: 1.2rem;
            }
        }

        &.center {
            display: flex;
            align-items: center;

            a {
                margin: 0 auto;
            }

            img {
                max-height: 50px;
                max-width: 75px;
                margin: 0 auto;
            }
        }
        &.right {
            display: flex;
            align-items: center;

            img {
                max-height: 50px;
                max-width: 75px;
                margin: 0 10px;
            }

            .diagramsLink {
                text-align: right;
                line-height: 1.6rem;
                display: inline;
                font-family: "Ysabeau";
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 0.05rem;

                a {
                    border-bottom: 2px solid black;

                    &:hover {
                        text-decoration: none;
                    }
                }
            }
        }
    }

    .indexFooter {
        padding-top: 1.5rem;
        border-top: 2px solid black;
        grid-column: span 3;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap:20px;

        img {
            margin: 0 auto;
        }
    }

    .pageTitle {
        display: block;
        font-family: "Ysabeau";
        font-size: 1.75rem;
        line-height: 1.7rem;
        margin-bottom: 4px;
        font-weight: bold;
    }

    ul {
        margin: 0;
        padding:0;
    }

    li {
        font-family: "Ysabeau";
        margin: 0;
        padding: 0;
        list-style-type: none;
        font-size: 1.2rem;
    }

    a {
        color: inherit;
    }

    @include respond-to(computer) {
        #indexInner {
            max-width: 900px;
            width: 90vw;
            margin: 0 auto;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            column-gap: 20px;
            row-gap: 2rem;
        }
    }
    @include respond-to(phone) {
        .bbeLink {
            display: none !important;
        }

        #indexInner {
            max-width: 900px;
            width: 90vw;
            margin: 0 auto;
            display: grid;
            grid-template-columns: 1fr 1fr;
            column-gap: 5px;
        }

        .page {
            grid-column: span 1;
            margin: 0.4rem 0;
            text-align: center !important;

            .pageTitle {
                font-size: 1.1rem;
                line-height: 1rem;
                text-align: center;
            }

            ul {
                li {
                    text-align: center;
                    font-size: 0.9rem;
                    line-height: 1.1rem;
                }
            }
        }
        .indexFooter {
            margin-top: 1rem;
            padding-top: 0;
            border-top: 2px solid black;
            grid-column: span 2;
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            column-gap:5px;

            img {
                margin: 0 auto;
            }
        }
        .page {
            grid-column: span 1;
            vertical-align: top;

            &.left {
                display: flex;
                align-items: left;
                flex-direction: column;

                a {
                    display: flex;
                    align-items: left;
                    flex-direction: column;
                }

                img {
                    max-height: 40px;
                    max-width: 50px;
                    margin: 0 10px !important;
                    display: block;
                }
            }

            &.center {
                display: flex;
                align-items: center;

                a {
                    margin: 0 auto !important;
                }

                img {
                    max-height: 40px;
                    max-width: 50px;
                    margin: 0 10px !important;
                }
            }

            &.right {
                display: flex;
                align-items: center;

                img {
                    max-height: 50px;
                    max-width: 75px;
                    margin: 0 10px;
                }

                .diagramsLink {
                    text-align: right;
                    line-height: 0.8rem;
                    font-size: 0.6rem;
                    display: inline;
                    font-family: "Ysabeau";
                    font-weight: bold;
                    text-transform: uppercase;
                    letter-spacing: 0.05rem;

                    a {
                        border-bottom: none;

                        &:hover {
                            text-decoration: none;
                        }
                    }
                }
            }
        }
    }
</style>
